import './ChromeSuggestionBanner.scss';

import React, { useState } from 'react';
import { detectBrowser, getChromeDownloadUrl } from '../../utils/browserDetector';

import { useTranslation } from 'react-i18next';

// 不再需要props，组件内部会检测browserInfo

/**
 * Chrome建议横幅
 * 在页面顶部显示，建议用户使用Chrome以获得更佳体验
 */
const ChromeSuggestionBanner: React.FC = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const browserInfo = detectBrowser();
  const chromeDownloadUrl = getChromeDownloadUrl(browserInfo.isMobile);

  // 检查用户是否已经关闭过横幅（使用sessionStorage，仅在当前会话中记住）
  React.useEffect(() => {
    const dismissed = sessionStorage.getItem('chromeBannerDismissed');
    if (dismissed === 'true') {
      setIsVisible(false);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('chromeBannerDismissed', 'true');
  };

  // 如果不需要建议Chrome或者用户已关闭横幅，则不显示
  if (!browserInfo.shouldSuggest || !isVisible) {
    return null;
  }

  return (
    <div className='chrome-suggestion-banner'>
      <div className='banner-content'>
        <div className='banner-icon'>
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path
              d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z'
              fill='currentColor'
            />
          </svg>
        </div>
        <div className='banner-message'>
          <span className='banner-text'>
            {browserInfo.isMobile
              ? t('browserWarning.suggestion.messageMobile')
              : t('browserWarning.suggestion.message')}
          </span>
        </div>
        <div className='banner-actions'>
          <a href={chromeDownloadUrl} target='_blank' rel='noopener noreferrer' className='banner-button download-btn'>
            {browserInfo.isMobile
              ? t('browserWarning.suggestion.downloadButtonMobile')
              : t('browserWarning.suggestion.downloadButton')}
          </a>
          <button
            className='banner-button close-btn'
            onClick={handleClose}
            aria-label={t('browserWarning.suggestion.close')}>
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChromeSuggestionBanner;
